(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-after-sale-support"] && !Shopify.designMode) return;
  try {
    
class CCSupport extends HTMLElement {
connectedCallback(){
if(this.ready)return;this.ready=true;this.slides=[...this.querySelectorAll('.cc-support__review')];this.dots=[...this.querySelectorAll('[data-slide]')];this.current=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;this.focused=false;this.visible=false;this.querySelector('.cc-support__controls').hidden=false;this.toggle=this.querySelector('[data-pause-toggle]');
this.querySelector('[data-prev]').addEventListener('click',()=>this.manual(this.current-1));this.querySelector('[data-next]').addEventListener('click',()=>this.manual(this.current+1));this.dots.forEach((d,i)=>d.addEventListener('click',()=>this.manual(i)));
this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.updateToggle();});
this.addEventListener('mouseenter',()=>this.hovered=true);this.addEventListener('mouseleave',()=>this.hovered=false);this.addEventListener('focusin',()=>this.focused=true);this.addEventListener('focusout',()=>setTimeout(()=>this.focused=this.contains(document.activeElement),0));
this.observer=new IntersectionObserver(e=>this.visible=e[0].isIntersecting);this.observer.observe(this);
this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.focused&&this.visible&&!document.hidden)this.show(this.current+1);},9000);
this.resize=new ResizeObserver(()=>this.sizeSlides());this.resize.observe(this.querySelector('.cc-support__slides'));document.fonts.ready.then(()=>this.sizeSlides());this.updateToggle();

}
sizeSlides(){let h=0;this.slides.forEach(s=>{const hidden=s.hidden;s.hidden=false;h=Math.max(h,s.getBoundingClientRect().height);s.hidden=hidden;});const c=this.querySelector('.cc-support__slides'),style=getComputedStyle(c);c.style.minHeight=(h+parseFloat(style.paddingTop)+parseFloat(style.paddingBottom)+2)+'px';}
manual(i){this.paused=true;this.updateToggle();this.show(i);}
show(i){this.current=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>s.hidden=n!==this.current);this.dots.forEach((d,n)=>d.setAttribute('aria-pressed',String(n===this.current)));}
updateToggle(){this.toggle.textContent=this.paused?'▶':'Ⅱ';this.toggle.setAttribute('aria-label',this.paused?this.dataset.play:this.dataset.pause);}
disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.resize?.disconnect();this.ready=false;}
}
if(!customElements.get('cc-support'))customElements.define('cc-support',CCSupport);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-champion-catalog"] && !Shopify.designMode) return;
  try {
    
function ccInitChampion(){document.querySelectorAll('.cc-champion').forEach(function(root){if(root.dataset.initialized)return;root.dataset.initialized='true';const choices=Array.from(root.querySelectorAll('.cc-champion__platform'));const cards=Array.from(root.querySelectorAll('.cc-champion__results .cc-champion__card'));const hp=root.querySelector('#ChampionHorsepower');const results=root.querySelector('#ChampionModels');let platform=null;function filterModels(){const visible=cards.filter(function(card){return (!platform||card.dataset.platform===platform)&&(hp.value==='all'||card.dataset.horsepower===hp.value);});cards.forEach(function(card){card.hidden=!visible.includes(card);});root.querySelector('[data-model-count]').textContent=root.dataset.resultsLabel+' '+visible.length;}function choosePlatform(value,scroll){platform=value;results.hidden=false;choices.forEach(function(choice){choice.setAttribute('aria-current',String(choice.dataset.platform===value));});hp.replaceChildren();const all=document.createElement('option');all.value='all';all.textContent=root.dataset.allHp;hp.append(all);Array.from(new Set(cards.filter(function(card){return card.dataset.platform===value;}).map(function(card){return card.dataset.horsepower;}))).sort(function(a,b){return Number(a)-Number(b);}).forEach(function(value){const option=document.createElement('option');option.value=value;option.textContent=platform==='duplex'?'2 × '+value+' HP':value+' HP';hp.append(option);});filterModels();if(scroll){const url=new URL(location.href);url.searchParams.set('platform',value);url.searchParams.delete('hp');url.hash='ChampionModels';history.replaceState(null,'',url);results.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});results.focus({preventScroll:true});}}choices.forEach(function(choice){choice.addEventListener('click',function(event){event.preventDefault();choosePlatform(choice.dataset.platform,true);});});hp.addEventListener('change',function(){filterModels();const url=new URL(location.href);url.searchParams.set('hp',hp.value);history.replaceState(null,'',url);});const params=new URLSearchParams(location.search);if(choices.some(function(choice){return choice.dataset.platform===params.get('platform');})){choosePlatform(params.get('platform'),false);if(Array.from(hp.options).some(function(option){return option.value===params.get('hp');})){hp.value=params.get('hp');filterModels();}}else{results.hidden=true;}const model=root.querySelector('#ChampionModel');const method=root.querySelector('#ChampionMethod');const phone=root.querySelector('#ChampionPhone');function selectModel(value){if(!model)return;const option=Array.from(model.options).find(function(o){return o.value===value;});if(option)model.value=value;root.querySelectorAll('a[href^="sms:"]').forEach(function(a){a.href='sms:+14302156412?body='+encodeURIComponent('I would like a Champion compressor quote for '+(model.value==='Help me choose'?'help selecting a machine':model.value)+'. Delivery ZIP: ');});}if(model){selectModel(new URLSearchParams(location.search).get('model'));model.addEventListener('change',function(){selectModel(model.value);});}root.querySelectorAll('.cc-champion__model-quote').forEach(function(link){link.addEventListener('click',function(event){event.preventDefault();selectModel(link.dataset.model);const url=new URL(location.href);url.searchParams.set('model',link.dataset.model);url.hash='ChampionQuote';history.replaceState(null,'',url);const quote=root.querySelector('#ChampionQuote');quote.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});quote.focus({preventScroll:true});});});if(method&&phone){function updatePhone(){phone.required=method.value!=='Email';root.querySelector('[data-phone-required]').hidden=!phone.required;}method.addEventListener('change',updatePhone);updatePhone();}});}ccInitChampion();document.addEventListener('shopify:section:load',ccInitChampion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-equipment-quote"] && !Shopify.designMode) return;
  try {
    
function ccInitQuoteContact(){
document.querySelectorAll('.cc-equipment-quote').forEach(function(section){
if(section.dataset.initialized)return;
section.dataset.initialized='true';
section.querySelectorAll('.cc-equipment-quote__method input').forEach(function(input){
input.addEventListener('change',function(){
const native=section.querySelector('.cc-native-request');
if(native){
const method=native.querySelector('[name="contact[preferred_contact_method]"]');
const phone=native.querySelector('[name="contact[phone]"]');
if(method)method.value=input.value==='phone'?'Phone':'Email';
if(phone){phone.required=input.value==='phone';const mark=phone.parentElement.querySelector('.cc-phone-required');if(mark)mark.hidden=input.value!=='phone';}
}
const active=section.querySelector('.cc-equipment-quote__panel:not([hidden])');
const next=section.querySelector('[data-contact-method="'+input.value+'"]');
if(!next||active===next)return;
const oldRoot=active&&active.querySelector('shopify-forms-embed');
const newRoot=next.querySelector('shopify-forms-embed');
if(oldRoot&&newRoot&&oldRoot.shadowRoot&&newRoot.shadowRoot){
oldRoot.shadowRoot.querySelectorAll('input,textarea').forEach(function(field){
if(!field.name||!field.value||field.type==='hidden'||field.type==='checkbox'||field.type==='radio')return;
const target=Array.from(newRoot.shadowRoot.querySelectorAll('input,textarea')).find(function(other){return other.name===field.name;});
if(!target)return;
const setter=Object.getOwnPropertyDescriptor(target.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:HTMLInputElement.prototype,'value').set;
setter.call(target,field.value);
target.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
target.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
});
}
section.querySelectorAll('.cc-equipment-quote__panel').forEach(function(panel){panel.hidden=panel!==next;});
});
});
});
}
ccInitQuoteContact();
document.addEventListener('shopify:section:load',ccInitQuoteContact);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-equipment-showcase"] && !Shopify.designMode) return;
  try {
    
function ccInitShowcases(){
document.querySelectorAll('.cc-showcase__video').forEach(function(video){
if(video.dataset.initialized)return;
video.dataset.initialized='true';
const source=video.querySelector('source');
let loaded=false;
let interacted=false;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
video.addEventListener('pointerdown',function(){interacted=true;});
video.addEventListener('keydown',function(){interacted=true;});
function loadVideo(){if(loaded)return;source.src=source.dataset.src;video.muted=true;video.load();loaded=true;}
function start(){loadVideo();if(!reduced.matches&&!interacted)video.play().catch(function(){});}
video.addEventListener('click',loadVideo,{once:true});
if('IntersectionObserver' in window){
const observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting)start();else if(loaded)video.pause();});},{rootMargin:'160px 0px',threshold:0.05});
observer.observe(video);
}else{loadVideo();}
});
}
ccInitShowcases();
document.addEventListener('shopify:section:load',ccInitShowcases);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-home-catalog-video"] && !Shopify.designMode) return;
  try {
    
function ccInitCatalogVideos(){
document.querySelectorAll('[data-catalog-video]').forEach(function(frame){
if(frame.dataset.initialized)return;
frame.dataset.initialized='true';
const preview=frame.querySelector('.cc-catalog-video__preview');
const player=frame.querySelector('.cc-catalog-video__player');
const video=player.querySelector('video');
const close=player.querySelector('.cc-catalog-video__close');
const error=player.querySelector('.cc-catalog-video__error');
let inView=false;
let started=false;
let userPaused=false;
let dismissed=false;
function showPlayer(){
preview.hidden=true;preview.setAttribute('aria-expanded','true');player.hidden=false;
if(!video.getAttribute('src')){video.src=video.dataset.src;video.load();}
}
function showPreview(){
player.hidden=true;preview.hidden=false;preview.setAttribute('aria-expanded','false');
}
preview.addEventListener('click',function(){
dismissed=false;userPaused=false;started=true;
showPlayer();video.focus();video.play().catch(function(){video.focus();});
});
close.addEventListener('click',function(){
dismissed=true;video.pause();showPreview();preview.focus();
});
video.addEventListener('pause',function(){if(inView&&!video.ended&&!dismissed)userPaused=true;});
video.addEventListener('play',function(){userPaused=false;});
video.addEventListener('error',function(){error.hidden=false;});
if('IntersectionObserver' in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
const observer=new IntersectionObserver(function(entries){
entries.forEach(function(entry){
inView=entry.isIntersecting&&entry.intersectionRatio>=0.5;
if(!inView){video.pause();return;}
if(dismissed||userPaused||video.ended)return;
if(!started){video.muted=true;showPlayer();started=true;}
video.play().catch(function(){if(video.paused){userPaused=true;showPreview();}});
});
},{threshold:[0,0.5]});
observer.observe(frame);
document.addEventListener('visibilitychange',function(){if(document.hidden)video.pause();});
}
});
}
ccInitCatalogVideos();
document.addEventListener('shopify:section:load',ccInitCatalogVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-service-request"] && !Shopify.designMode) return;
  try {
    
const ccObservedRequestRoots=new WeakSet();
function ccApplySharedRequest(){
const section=document.querySelector('.cc-service-request');
if(!section)return false;
const select=section.querySelector('#cc-shared-request-type');
const embed=section.querySelector('shopify-forms-embed');
const root=embed&&embed.shadowRoot;
if(!root)return false;
if(!ccObservedRequestRoots.has(root)){ccObservedRequestRoots.add(root);new MutationObserver(ccApplySharedRequest).observe(root,{childList:true,subtree:true});}
const field=root.querySelector('textarea');
if(!field)return false;
const prefix='Service requested: '+select.value+'\n\n';
if(field.dataset.ccRequestPrefix===prefix)return true;
let text=field.value;
const previous=field.dataset.ccRequestPrefix;
if(previous&&text.startsWith(previous))text=text.slice(previous.length);
const setter=Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value').set;
setter.call(field,prefix+text);
field.dataset.ccRequestPrefix=prefix;
field.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
field.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
return true;
}
function ccChooseSharedRequest(type){
const select=document.getElementById('cc-shared-request-type');
if(select)select.value=type;
ccApplySharedRequest();
}
document.addEventListener('click',function(event){
const link=event.target.closest('a[href="#ContactForm"],a[href="#equipment-quote"]');
if(!link)return;
let type=link.getAttribute('href')==='#equipment-quote'?'Equipment Quote':'Service or Repair';
if(link.classList.contains('cc-priority__request'))type='Priority Response';
if(link.classList.contains('cc-owner__button'))type='Expert Diagnostics';
if(link.classList.contains('cc-maintenance__button'))type='Planned Maintenance';
const details=link.closest('.cc-service-details');
if(details&&details.id==='expert-diagnostics')type='Expert Diagnostics';
if(details&&details.id==='planned-maintenance')type='Planned Maintenance';
if(details&&details.id==='equipment-sales')type='Equipment Quote';
ccChooseSharedRequest(type);
});
document.addEventListener('change',function(event){if(event.target.id==='cc-shared-request-type')ccApplySharedRequest();});
document.addEventListener('shopify:section:load',ccApplySharedRequest);
document.addEventListener('DOMContentLoaded',ccApplySharedRequest);
new MutationObserver(ccApplySharedRequest).observe(document.documentElement,{childList:true,subtree:true});
let ccRequestAttempts=0;
const ccRequestTimer=setInterval(function(){ccRequestAttempts++;if(ccApplySharedRequest()||ccRequestAttempts>=60)clearInterval(ccRequestTimer);},500);
ccApplySharedRequest();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

  
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click',function(event){
const button=event.target.closest('[data-cc-reviews-toggle]');
if(!button)return;
const root=button.closest('[data-cc-product-reviews]');
const expanded=button.getAttribute('aria-expanded')!=='true';
root.classList.toggle('is-expanded',expanded);
button.setAttribute('aria-expanded',String(expanded));
button.textContent=expanded?button.dataset.collapseLabel:button.dataset.expandLabel;
if(!expanded)root.scrollIntoView({block:'nearest'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
